module.exports = __webpack_public_path__ + "static/img/zanting.e494cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zanting.png
// module id = FALE
// module chunks = 24